import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractExtendedTemplates = [
  {
    id: '-205001',
    language: Language.EN,
    subject: 'Extension of the lease term',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_EXTENDED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>Your lease contract has been extended to: {{formatDate lease.endDate}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-205002',
    language: Language.FR,
    subject: 'Extension de la durée du bail',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_EXTENDED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Votre bail a été prolongé jusqu'au: {{formatDate lease.endDate}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-205003',
    language: Language.NL,
    subject: 'Verlenging van de huur termijn',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_EXTENDED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Uw huurcontract wordt verlengd tot: {{formatDate lease.endDate}}.</p>
          <p>Groeten.</p>
          `,
  },
  {
    id: '-205004',
    language: Language.DE,
    subject: 'Verlängerung der Mietdauer',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_EXTENDED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Ihr Mietvertrag wurde verlängert bis: {{formatDate lease.endDate}}.</p>
          <p>Mit freundlichen Grüßen.</p>
          `,
  },
];
